import React from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import logo from '../images/polymedia-citrus.png';
import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined} from 'Skelet/src/modules/fetch.action.js'


class Poll extends React.Component {

  constructor(props) {
    super(props);

    let embed_interface = false;
    let poll_language = "NL";
    let active_poll = false;
    if(typeof URLSearchParams === "function") {
      let params = new URLSearchParams(this.props.location.search);
      let param_embed = params.get('embed');
      let param_lang = params.get('lang');
      let param_ap = params.get('ap');
      if(param_embed === "") {
        embed_interface = true;
      }
      if(param_lang && param_lang.trim() !== "" && param_lang.toLowerCase() === "en") {
        poll_language = "EN";
      }
      if(param_ap === "") {
        active_poll = true;
      }
    }
    document.documentElement.setAttribute('lang', poll_language.toLowerCase());

    const checkCookie = this.getCookie(props.match.params.id);
    this.state = {
      selected: checkCookie ? checkCookie : "",
      cookie: checkCookie,
      embed_interface,
      poll_language,
      active_poll,
    };
  }

  componentWillMount() {
    if(!this.state.active_poll) {
      this.props.fetchDataIfReady(config.api_token, "poll_"+this.props.match.params.id, "GET", config.api_url+"/poll/"+this.props.match.params.id);
    } else {
      this.props.fetchDataIfReady(config.api_token, "ap_"+this.props.match.params.id, "GET", config.api_url+"/embed-once/"+this.props.match.params.id, undefined, null, true, false, false, false, false, null, "poll_"+this.props.match.params.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(!this.state.active_poll) {
      this.props.fetchDataIfUndefined(config.api_token, "poll_"+nextProps.match.params.id, "GET", config.api_url+"/poll/"+nextProps.match.params.id);
    } else {
      if(!nextProps.apiData["ap_"+nextProps.match.params.id].isFetching) {
        let poll_ref_id = nextProps.apiData["ap_"+nextProps.match.params.id].data.poll_ref_id;
        this.props.fetchDataIfUndefined(config.api_token, "poll_"+poll_ref_id, "GET", config.api_url+"/poll/"+poll_ref_id);
        let checkCookie = this.getCookie(nextProps.match.params.id);
        this.setState({selected:(checkCookie ? checkCookie : ""), cookie: checkCookie});
      }
    }
  }

  render() {
    let poll_ref_id = this.props.match.params.id;
    if(this.props.apiData["ap_"+poll_ref_id] !== undefined) poll_ref_id = this.props.apiData["ap_"+poll_ref_id].data.poll_ref_id;
    const api_poll = this.props.apiData["poll_"+poll_ref_id];
    const poll_language = this.state.poll_language;
    if(api_poll === undefined || api_poll.isFetching) {
      return <div>Loading Poll..</div>;
    } else if(api_poll.data.length === 0) {
      return <div>Failed to load Poll.</div>;
    }

    const poll = this.props.apiData["poll_"+poll_ref_id].data;
    document.title = "Citrus Poll · "+poll.name+" · Citrus by Polymedia";
    const poll_options = poll.options.map(function(item, i) {
      let cN = null;
      if(this.state.selected !== "") {
        let voted = this.state.cookie ? " voted" : "";
        cN = (this.state.selected === item ? "active" : "inactive") + voted;
      }
      return <button key={i} onClick={!this.state.cookie ? () => this.vote(item) : null} className={cN} style={{border:"0"}}><span><i></i> {item}</span></button>;
    }.bind(this));

    import('../poll.css');
    return (
      <div style={(!this.state.embed_interface) ? {padding:"1em", background:"#f5f5f5", minHeight:"100vh"} : null}>
        <div className="poll" style={(!this.state.embed_interface) ? {margin:"2em auto", maxWidth:"700px"} : null}>
          <div className="poll-header"><div>{poll.name}</div><div style={(!this.state.embed_interface) ? {display:"none"} : null}><a href="https://citrus.polymedia.nl/" target="_blank" rel="noopener noreferrer"><img src={logo} alt="Citrus by Polymedia" /></a></div><br style={{clear:"both"}}/></div>
          <div className="poll-body">
            {poll_options}
          </div>
          <div className="poll-footer">
            {poll_language === "NL" && !this.state.cookie && <button onClick={!this.state.cookie && this.state.selected ? () => this.confirm() : null} className={this.state.selected !== "" ? "selected" : null} style={{border:"0"}}>Stem</button>}
            {poll_language === "EN" && !this.state.cookie && <button onClick={!this.state.cookie && this.state.selected ? () => this.confirm() : null} className={this.state.selected !== "" ? "selected" : null} style={{border:"0"}}>Vote</button>}
            {poll_language === "NL" && this.state.cookie && <span>Bedankt voor jouw stem!</span>}
            {poll_language === "EN" && this.state.cookie && <span>Thank you for voting!</span>}
          </div>
        </div>
        {!this.state.embed_interface && <div className="logo-footer"><a href="https://citrus.polymedia.nl/" target="_blank" rel="noopener noreferrer"><img src={logo} alt="Citrus by Polymedia" /></a></div>}
      </div>
    );
  }


  vote = label => {
    this.setState({selected:label});
  };

  /* The navigator.cookieEnabled property returns true if cookies are enabled, otherwise false:
  console.log(navigator.userAgent);
  console.log(navigator.vendor);
  var url = (window.location !== window.parent.location)
  ? document.referrer
  : document.location.href;
  // if url === "" : maybe Edge?
  console.log(url);*/
  confirm() {
    let poll_ref_id = this.props.match.params.id;
    if(this.props.apiData["ap_"+poll_ref_id] !== undefined) poll_ref_id = this.props.apiData["ap_"+poll_ref_id].data.poll_ref_id;
    this.props.fetchDataIfReady(config.api_token, "bin", "POST", config.api_url+"/vote", JSON.stringify({id:poll_ref_id, label:this.state.selected, type:"p"}), null, true);
    document.cookie = poll_ref_id+"="+this.state.selected+"; path=/";
    this.setState({cookie:this.getCookie(poll_ref_id)});
  };

  getCookie = cname => {
    var name = cname + "=";
    if(this.props.apiData["ap_"+cname] !== undefined) name = this.props.apiData["ap_"+cname].data.poll_ref_id + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

}


function mapStateToProps(state) {
  return {
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Poll)



// WEBPACK FOOTER //
// ./src/containers/Poll.js